import { ApiPath } from '..';
import { ApiDataParser } from './ApiDataParser';

// TODO Parse collection of Programme
export const programmesDataParser: ApiDataParser<ApiPath.Programmes> = (data) =>
  data.map((item) => item);
